<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" class="active" routerLink="/dashboard/Save-Quotes"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li routerLink="/dashboard/forms"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li routerLink="/dashboard/resources"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <label class="fs-16 semi-bold cp ml-3" >ISP ({{IspCount}})</label>
        <label class="switch1" >
        <div class="clear5"></div>
        <input type="checkbox" (change)="newlyUploadedDoc($event)" value="false" >
        <span class="slider1 round1"></span>
        </label>
        <label class="fs-16 semi-bold cp ml-3" >VTC ({{VTCCount}})</label>
        <div class="p-4" *ngIf="showVTCDashboard==false">
            
            <label class="bold fs-18 txt-black">Saved Quotes ({{saveQuoteTotal}})</label>
            <div class="clear10"></div>
            <div class="row whiteBox">
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <button type="button" (click)=" this.filterModal = !this.filterModal;" class=" fs-14 regular filterbtn">Filters &nbsp;<img src="./assets/images/popupIcon.png"> </button>
                    <img *ngIf="AppliedFilter==true" (click)="refreshPage()" style="padding: 6px;height: 33px;" src="./assets/images/refresh.png" class="cp disin ml-1" data-toggle="tooltip" title="Clear Filter">
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <div class="row">
                        <label class="fs-16 mt-1 mb-0 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 text-right">Search:&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input type="text" class="form-control forminput col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8 Tab" placeholder="Quote Name,Quote Description" [(ngModel)]="savedQuoteSearchString" (input)="onSearchSavedQuote(savedQuoteSearchString)"> 
                    </div>
                </div>
            </div><div class="clear20"></div>
            <div class="tableheadFix">
                <table id="LinkToLead" class="w100">
                    <thead class="nowrap">
                        <tr>
                            <th *ngIf="showQuoteNumber">
                                <div class="d-flex flex-row align-items-center">
                                    <span>NUMBER</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteNumber')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteNumber')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showName">
                                <div class="d-flex flex-row align-items-center">
                                    <span>QUOTE NAME</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteName')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteName')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showAgentName">
                                <div class="d-flex flex-row align-items-center">
                                    <span>AGENT'S NAME</span>
                                    <div class="d-flex flex-column ml-4">
                                        <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up" (click)="onPolicySortAsc('agentId.lead.firstName')"></i>
                                            <i class="fa fa-caret-down" (click)="onPolicySortDsc('agentId.lead.firstName')"></i>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showDiscription">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DESCRIPTION</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteDescription')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteDescription')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showDepartureDate">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DEPARTURE DATE</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('effectiveDate')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('effectiveDate')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showDateSaved">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DATE SAVED</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('createdAt')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('createdAt')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showExpiryDate">
                                <div class="d-flex flex-row align-items-center">
                                    <span class="tooltip1">EXPIRY DATE 
                                        <img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2">
                                            This is the 'Expiry Date' of the quote.<br> Quotes are saved for 3 weeks.</span>
                                        </div>
                                    </span>
                                    
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('expiryDate')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('expiryDate')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showStatus">
                                <div class="d-flex flex-row align-items-center">
                                    <span>PAYMENT LINK SENT</span>
                                    <div class="d-flex flex-column ml-4">
                                        
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showSummary">
                                <div class="d-flex flex-row align-items-center">
                                    <span>SUMMARY</span>
                                    <div class="d-flex flex-column ml-4">
                                        <!-- <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i> -->
                                    </div>
                                </div>
                            </th>
                            <th style="width: 50px;" (click)="notificationShow()">
                                <img src="./assets/images/theadset.png" class="cp">
                            </th>
                            <div id="popup" *ngIf="noti" class="notification text-left">
                                <div class="row">
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                        <label class="fs-16 semi-bold black pad20 mb-0">Columns</label>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                        <button type="button" class="closebtn1 fs-16 semi-bold" (click)="notificationShow()">Close</button>
                                    </div>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showQuoteNumber" (change)="showQuoteNumber=!showQuoteNumber"> 
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Quote Number</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showName" (change)="showName=!showName"> 
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Quote Name</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showAgentName" (change)="showAgentName=!showAgentName">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Agent's Name</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDiscription" (change)="showDiscription=!showDiscription">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Description</span>
                                </div>
                                <!-- <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showStatus" (change)="showStatus=!showStatus">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Status</span>
                                </div> -->
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDepartureDate" (change)="showDepartureDate=!showDepartureDate">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Departure Date</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDateSaved" (change)="showDateSaved=!showDateSaved">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Date Saved</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showExpiryDate" (change)="showExpiryDate=!showExpiryDate">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Expiry Date</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showSummary" (change)="showSummary=!showSummary">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Summary</span>
                                </div>
                            </div>
                        </tr>
                    </thead>
                    <tbody class="">
                        <tr *ngFor="let item of savedQuotes | paginate: { itemsPerPage: onSelectSizePage, currentPage: p, totalItems: saveQuoteTotal};let i=index">
                            <td *ngIf="showQuoteNumber"><span class="link cp breakAll" (click)="gotoQuotePurchase(item.id)">{{item.quoteNumber}}</span></td>
                            <td *ngIf="showName"><span class="link cp breakAll" (click)="gotoQuotePurchase(item.id)">{{item.quoteName}}</span></td>
                            <td *ngIf="showAgentName ">
                                <div *ngIf="item.agentId != null">{{item.agentId.lead.firstName}} {{item.agentId.lead.lastName}}</div>
                                <div *ngIf="item.agentId == null">-</div></td>
                            <td *ngIf="showDiscription"><span class="breakAll">{{item.quoteDescription}}</span></td>
                            <td *ngIf="showDepartureDate">{{item.effectiveDate  | date:'dd MMM yyyy' }}</td>
                            <td *ngIf="showDateSaved">{{item.updatedAt  | date:'dd MMM yyyy' }}</td>
                            <td *ngIf="showExpiryDate">{{item.quoteExpiryDate | date:'dd MMM yyyy' }} </td>
                            <td *ngIf="showStatus">
                                <span *ngIf="item.isPaymentLinkAlreadySent" class="breakAll">{{item.paymentSentDate | date:'dd MMM yyyy HH:mm'}}</span>
                                <span *ngIf="!item.isPaymentLinkAlreadySent">-</span>
                            </td>
                            <td *ngIf="showSummary">
                                <div *ngIf="item.effectiveDate != null">Departure Date: {{item.effectiveDate | date:'dd MMM yyyy'}}</div>
                                <div *ngIf="item.expiryDate != null">Return Date: {{item.expiryDate | date:'dd MMM yyyy'}}</div>
                                <div *ngIf="item.noOfDays != null">Days: {{item.noOfDays}}</div>
                                <div *ngIf="item.province != null">Resident of: {{item.province}}</div>
                                <div *ngIf="item.planName != null">Plan: {{item.planName}}</div>
                            </td>
                            <td class="cp" (click)="toggleMenu();check(i)">
                                <img class="cp" src="./assets/images/dots.png">
                                <div id="popupone" *ngIf="isMenuOpen && index==i" #menu class="labelbox menu">
                                    <label *ngIf="item.isPaymentLinkAlreadySent" class="fs-14 semi-bold cp m-0" (click)="sendPaymentLink(item.id,item.purchaserEmailAddress)">Resend Payment Link</label>
                                    <div class="clear10"></div>
                                    <label class="fs-14 semi-bold cp m-0" (click)="sendEmail(item.id)">Email</label>
                                    <div class="clear10"></div>
                                    <label class="fs-14 semi-bold cp red" (click)="deleteSaveQuote(item.id)">Delete</label>
                                </div>
                            </td>
                        </tr>    
                    </tbody>
                </table>
                <pagination-controls (click)="pageChnageDone(p)" (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div>
        </div>
        <div class="p-4" *ngIf="showVTCDashboard==true">
            
            <label class="bold fs-18 txt-black">Saved Quotes ({{saveQuoteTotal}})</label>
            <div class="clear10"></div>
            <div class="row whiteBox">
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <button type="button" (click)=" this.filterModal = !this.filterModal;" class=" fs-14 regular filterbtn">Filters &nbsp;<img src="./assets/images/popupIcon.png"> </button>
                    <img *ngIf="AppliedFilter==true" (click)="refreshPage()" style="padding: 6px;height: 33px;" src="./assets/images/refresh.png" class="cp disin ml-1" data-toggle="tooltip" title="Clear Filter">
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <div class="row">
                        <label class="fs-16 mt-1 mb-0 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 text-right">Search:&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input type="text" class="form-control forminput col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8 Tab" placeholder="Quote Name,Quote Description" [(ngModel)]="savedQuoteSearchString" (input)="onSearchSavedQuote(savedQuoteSearchString)"> 
                    </div>
                </div>
            </div><div class="clear20"></div>
            <div class="tableheadFix">
                <table id="LinkToLead" class="w100">
                    <thead class="nowrap">
                        <tr>
                            <th *ngIf="showQuoteNumber">
                                <div class="d-flex flex-row align-items-center">
                                    <span>QUOTE NUMBER</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteNumber')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteNumber')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showName">
                                <div class="d-flex flex-row align-items-center">
                                    <span>QUOTE NAME</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteName')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteName')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showAgentName">
                                <div class="d-flex flex-row align-items-center">
                                    <span>AGENT'S NAME</span>
                                    <div class="d-flex flex-column ml-4">
                                        <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up" (click)="onPolicySortAsc('agentId.lead.firstName')"></i>
                                            <i class="fa fa-caret-down" (click)="onPolicySortDsc('agentId.lead.firstName')"></i>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <!-- <th *ngIf="showDiscription">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DESCRIPTION</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('quoteDescription')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('quoteDescription')"></i>
                                    </div>
                                </div>
                            </th> -->
                            <th *ngIf="showDepartureDate">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DEPARTURE DATE</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('effectiveDate')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('effectiveDate')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showDateSaved">
                                <div class="d-flex flex-row align-items-center">
                                    <span>DATE SAVED</span>
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('createdAt')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('createdAt')"></i>
                                    </div>
                                </div>
                            </th>
                            <th *ngIf="showExpiryDate">
                                <div class="d-flex flex-row align-items-center">
                                    <span class="tooltip1">EXPIRY DATE 
                                        <img src="./assets/images/iIconblue.svg">
                                        <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2">
                                            This is the 'Expiry Date' of the quote.<br> Quotes are saved for 3 weeks.</span>
                                        </div>
                                    </span>
                                    
                                    <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up" (click)="onPolicySortAsc('expiryDate')"></i>
                                        <i class="fa fa-caret-down" (click)="onPolicySortDsc('expiryDate')"></i>
                                    </div>
                                </div>
                            </th>
                            <!-- <th *ngIf="showStatus">
                                <div class="d-flex flex-row align-items-center">
                                    <span>PAYMENT LINK SENT</span>
                                    <div class="d-flex flex-column ml-4">
                                        
                                    </div>
                                </div>
                            </th> -->
                            <th *ngIf="showSummary">
                                <div class="d-flex flex-row align-items-center">
                                    <span>SUMMARY</span>
                                    <div class="d-flex flex-column ml-4">
                                        <!-- <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i> -->
                                    </div>
                                </div>
                            </th>
                            <th style="width: 50px;" (click)="notificationShow()">
                                <img src="./assets/images/theadset.png" class="cp">
                            </th>
                            <div id="popup" *ngIf="noti" class="notification text-left">
                                <div class="row">
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                        <label class="fs-16 semi-bold black pad20 mb-0">Columns</label>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                        <button type="button" class="closebtn1 fs-16 semi-bold" (click)="notificationShow()">Close</button>
                                    </div>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showQuoteNumber" (change)="showQuoteNumber=!showQuoteNumber"> 
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Quote Number</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showName" (change)="showName=!showName"> 
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Quote Name</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showAgentName" (change)="showAgentName=!showAgentName">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Agent's Name</span>
                                </div>
                                <!-- <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDiscription" (change)="showDiscription=!showDiscription">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Description</span>
                                </div> -->
                                <!-- <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showStatus" (change)="showStatus=!showStatus">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Status</span>
                                </div> -->
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDepartureDate" (change)="showDepartureDate=!showDepartureDate">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Departure Date</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showDateSaved" (change)="showDateSaved=!showDateSaved">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Date Saved</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showExpiryDate" (change)="showExpiryDate=!showExpiryDate">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Expiry Date</span>
                                </div>
                                <div class="">
                                    <label class="container">
                                    <input type="checkbox" class="form-check-input" [checked]="showSummary" (change)="showSummary=!showSummary">
                                    <span class="checkmark"></span>
                                    </label>
                                    <span class="fs-14 regular ml30">Summary</span>
                                </div>
                            </div>
                        </tr>
                    </thead>
                    <tbody class="">
                        <tr *ngFor="let item of savedQuotes | paginate: { itemsPerPage: onSelectSizePage, currentPage: p, totalItems: saveQuoteTotal};let i=index">
                            <td *ngIf="showQuoteNumber"><span class="link cp breakAll" (click)="gotoQuotePurchase(item.id)">{{item.quoteNumber}}</span></td>
                            <td *ngIf="showName"><span class="link cp breakAll" (click)="gotoQuotePurchase(item.id)">{{item.quoteName}}</span></td>
                            <td *ngIf="showAgentName ">
                                <div *ngIf="item.agentId != null">{{item.agentId.lead.firstName}} {{item.agentId.lead.lastName}}</div>
                                <div *ngIf="item.agentId == null">-</div></td>
                            <!-- <td *ngIf="showDiscription"><span class="breakAll">{{item.quoteDescription}}</span></td> -->
                            <td *ngIf="showDepartureDate">{{item.effectiveDate  | date:'dd MMM yyyy' }}</td>
                            <td *ngIf="showDateSaved">{{item.updatedAt  | date:'dd MMM yyyy' }}</td>
                            <td *ngIf="showExpiryDate">{{item.quoteExpiryDate | date:'dd MMM yyyy' }} </td>
                            <!-- <td *ngIf="showStatus">
                                <span *ngIf="item.isPaymentLinkAlreadySent" class="breakAll">{{item.paymentSentDate | date:'dd MMM yyyy HH:mm'}}</span>
                                <span *ngIf="!item.isPaymentLinkAlreadySent">-</span>
                            </td> -->
                            <td *ngIf="showSummary">
                                <div *ngIf="item.effectiveDate != null">Departure Date: {{item.effectiveDate | date:'dd MMM yyyy'}}</div>
                                <div *ngIf="item.expiryDate != null">Return Date: {{item.expiryDate | date:'dd MMM yyyy'}}</div>
                                <div *ngIf="item.noOfDays != null">Days: {{item.noOfDays}}</div>
                                <div *ngIf="item.province != null">Resident of: {{item.province}}</div>
                                <div *ngIf="item.planName != null">Plan: {{item.planName}}</div>
                            </td>
                            <td class="cp" (click)="toggleMenu();check(i)">
                                <img class="cp" src="./assets/images/dots.png">
                                <div id="popupone" *ngIf="isMenuOpen && index==i" #menu class="labelbox menu">
                                    <label *ngIf="item.isPaymentLinkAlreadySent" class="fs-14 semi-bold cp m-0" (click)="sendPaymentLink(item.id,item.purchaserEmailAddress)">Resend Payment Link</label>
                                    <div class="clear10"></div>
                                    <label class="fs-14 semi-bold cp m-0" (click)="sendEmail(item.id)">Email</label>
                                    <div class="clear10"></div>
                                    <label class="fs-14 semi-bold cp red" (click)="deleteSaveQuote(item.id)">Delete</label>
                                </div>
                            </td>
                        </tr>    
                    </tbody>
                </table>
                <pagination-controls (click)="pageChnageDone(p)" (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div>
        </div>        
    </div>
</div>
<div id="filters" class="modal" [style.display]="filterModal ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-18 text46 semi-bold">Filters</span>
            <h6 class="close text-right" (click)="closeFilter()">&times;</h6>
        </div>
        <div class="modal-body">
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">Quote Name</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Quote Name" [(ngModel)]="quoteName">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">Quote Description</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Quote Description" [(ngModel)]="quoteDescription">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">Date Saved</label>
                        <!-- <div class="row">
                            <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5 mr-2" placeholder="DD-MMM-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                            <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="DD-MMM-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                        </div> -->
                        <div class="row">
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [(ngModel)]="applicationStartDate">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time> -->
                            <div class="policy-search-datepicker col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="datepicker1" placeholder="ddmmmyyyy" [(ngModel)]="dateSavedStartDate" (dateChange)="callApplicationStartDateFunction()" (click)="datepicker1.open()" (keyup.enter)="onclickfilterSavedQuote()">
                                    <mat-datepicker #datepicker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <label class="bold fs-16 txt-black col-sm-5 col-md-1 col-lg-1 col-xl-1 col-1 text-center">&nbsp;-&nbsp;</label>
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [(ngModel)]="applicationEndDate">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time> -->
                            <div class="policy-search-datepicker col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="datepicker2" placeholder="ddmmmyyyy" [(ngModel)]="dateSavedEndDate" (dateChange)="callApplicationEndDateFunction()" (click)="datepicker2.open()" (keyup.enter)="onclickfilterSavedQuote()">
                                    <mat-datepicker #datepicker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">First Name</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10"  placeholder="First Name" [(ngModel)]="firstName" (keyup.enter)="onclickfilterSavedQuote()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">Last Name</label>
                        <div>
                            <input type="text" class="form-control forminput col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" [(ngModel)]="lastName" (keyup.enter)="onclickfilterSavedQuote()">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <label class="regular fs-14 txt-black">Departure Date</label>
                        <div class="row">
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [(ngModel)]="departureStartDate">
                            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time> -->
                            <div class="policy-search-datepicker col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                              <mat-form-field appearance="fill">
                                  <input matInput [matDatepicker]="datepicker3" placeholder="ddmmmyyyy" [(ngModel)]="departureStartDate" (dateChange)="callDepartureStartDateFunction()" (click)="datepicker3.open()" (keyup.enter)="onclickfilterSavedQuote()">
                                  <mat-datepicker #datepicker3></mat-datepicker>
                              </mat-form-field>
                            </div>
                            <label class="bold fs-16 txt-black col-sm-5 col-md-1 col-lg-1 col-xl-1 col-1 text-center">&nbsp;-&nbsp;</label>
                            <!-- <input class="form-control forminput col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" [(ngModel)]="departureEndDate">
                            <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time> -->
                            <div class="policy-search-datepicker col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                              <mat-form-field appearance="fill">
                                  <input matInput [matDatepicker]="datepicker4" placeholder="ddmmmyyyy" [(ngModel)]="departureEndDate" (dateChange)="callDepartureEndDateFunction()" (click)="datepicker4.open()" (keyup.enter)="onclickfilterSavedQuote()">
                                  <mat-datepicker #datepicker4></mat-datepicker>
                              </mat-form-field>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="clear20"></div>
            <div class="text-right mr-5">
                <button type="button" class="fs-14 semi-bold addbtn" (click)="onclickfilterSavedQuote()">Apply</button>
            </div>
            <div class="clear10"></div>
        </div>
    </div>
  </div>
  <div id="printPopup" class="modal" [style.display]="printPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header text-center">
            
            <h6 class="close text-right" title="Close" (click)="printPopup=!printPopup">&times;</h6>
            <div class="fs-16 bold">Email</div>
            <!-- <div class="clear10"></div>
            <div class="fs-16 link regular cp" (click)="printPopup=!printPopup"></div> -->
        </div>
        <div class="modal-body">
            <div>
                <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com" [(ngModel)]="email1" (input)="onRemoveEmailError();emailCheck()">
                <p class="regular redstar" *ngIf="emailErrorFlag">Email is required</p>
                <p class="fs-14 regular redstar" *ngIf="emailNotValid">Email is not valid.</p>
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-14 bold okbtngreen" (click)="onSendEmail()">Send</button>
            </div>
        </div>
    </div>
  </div>